/**
 * 分享相关常量
 */
export var WechatJS = '//res.wx.qq.com/open/js/jweixin-1.3.2.js';
export var WechatBridge = '//tu.qq.com/websites/wxBridge.php';
export var QQJS = '//pub.idqqimg.com/qqmobile/qqapi.js?_bid=152';
export var MqzoneJS = '//qzs.qq.com/qzone/phone/m/v4/widget/mobile/jsbridge.js';
export var QQShuoshuoBridge = 'jsbridge://Qzone/writeMood?p=';
export var MaskImage = 'https://res.tu.qq.com/assets/opnewyear2016_img/share-guide.png';
